import styled from 'styled-components'
import media from '../../styles/media'

export const Container = styled.div`
  display: flex;
  width: 100%;
`
export const Main = styled.main`
  display: flex;
  width: 100%;
  ${media.sm`width: 85%`}
`
